import React, {Dispatch} from 'react';
import {connect} from "react-redux";
import moment from "moment";
import {Accordion, AccordionContent, AccordionTitle, Checkbox, Grid, GridColumn, GridRow, Icon, Label, Popup, Radio} from 'semantic-ui-react';
import {JobsDto, MenuDto, ResourceListOfModelyearDto, TranslationServiceDto} from 'src/services/Client';
import './ManagementView.less';
import Button from 'src/components/Button';
import HATEOASClient from 'src/services/HATEOASClient';
import _, {last} from "lodash";
import i18next from 'i18next';
import TrafficLight from 'src/components/TrafficLight';
import {DateFormatter} from 'src/utils/DateFormatter';
import {IReduxState} from 'src/redux/IReduxState';
import GeneralActions from 'src/redux/actions/GeneralActions';
import {AnyAction, compose} from 'redux';
interface ITechnicalTabProps {
    modelYears?: ResourceListOfModelyearDto;
    jobs?: JobsDto[];
    client: HATEOASClient;
    baseLinks?: MenuDto;
    addLoadingMessage: (message: string) => void;
    removeLoadingMessage: (message: string) => void;
    t: i18next.TranslationFunction;
    ReceiveTranslationServiceAction: (translationService: any) => void;
    userDetails?: any;
}
interface ITechnicalTabState {
    activeIndex: number;
    parentActiveIndex: number;
    jobs: any;
    updatedJobIds: number[];
    translationService: string;
}
const config = {
    red: {
        backgroundColor: '#950014',
    },
    green: {
        backgroundColor: 'green',
    },
};
class TechnicalTab extends React.Component<ITechnicalTabProps, ITechnicalTabState> {
    constructor(props: ITechnicalTabProps) {
        super(props);
        this.state = {
            activeIndex: -1,
            parentActiveIndex: -1,
            jobs: [],
            updatedJobIds: [],
            translationService: "AWS_BEDROCK", // default

        };
    }
    componentDidMount(): void {
        this.loadJobs();
        const { userDetails } = this.props;
        const hasPrivilege = userDetails && userDetails.privileges &&
            userDetails.privileges.some((priv: any) =>
            priv.identifier === 'ADMIN_AREA_READ' || priv.identifier === 'ADMIN_AREA_WRITE'
        );

        if (hasPrivilege) {
            this.loadTranslationService();
        }
    }
    loadJobs = () => {
        const {client, baseLinks, modelYears} = this.props;
        if (baseLinks) {
            this.props.addLoadingMessage('Loading jobs');
            client.GET_getJobs(baseLinks).execute().then((response: any) => {
                const grouped = _(response).groupBy('linkedSystem').map((items, linkedSystem) => ({
                    linkedSystem: linkedSystem, jobs: _.map(items.sort((a: any, b: any) => a.name.localeCompare(b.name)))
                })).value();
                this.setState({jobs: [...grouped]});
                this.props.removeLoadingMessage('Loading jobs');
            });
        }
    }
    loadTranslationService = () => {
        const {client, baseLinks} = this.props;
        if (baseLinks) {
            this.props.addLoadingMessage('Loading translation services');
            client.GET_translationService(baseLinks).execute().then((response: any) => {
                if (response) {
                    this.setState({translationService: response.service});
                }
                this.props.removeLoadingMessage('Loading translation services');
            }).catch(() => {
                this.props.removeLoadingMessage('Loading translation services');
            });
        }
    }
    handleClick = (index: number) => {
        const {activeIndex} = this.state;
        const newIndex = activeIndex === index ? -1 : index;
        this.setState({activeIndex: newIndex});
    }
    handleParentClick = (index: number) => {
        const {parentActiveIndex} = this.state;
        const newIndex = parentActiveIndex === index ? -1 : index;
        this.setState({parentActiveIndex: newIndex});
    }
    handleActiveInactive = (e: any, {checked}: any) => {
        const jobs = this.state.jobs;
        const jobId = parseInt(e.target.id, 0);
        const updatedLinkedJobs = jobs.map((linkedSystem: any) => {
            const updatedJobs = linkedSystem.jobs.map((job: any) => {
                if (job.objectId === jobId) {
                    job.active = checked;
                }
                return job;
            });
            return {...linkedSystem, jobs: updatedJobs};
        });
        const updatedJobIds: number[] = this.state.updatedJobIds;
        if (updatedJobIds.indexOf(jobId) === -1) {
            updatedJobIds.push(jobId);
        }
        this.setState({jobs: [...updatedLinkedJobs], updatedJobIds: [...updatedJobIds]});
    }
    handleModelYearChange = (jobId: number, selectedModelYear: any) => {
        const jobs = this.state.jobs;
        const updatedLinkedJobs = jobs.map((linkedSystem: any) => {
            const updatedJobs = linkedSystem.jobs.map((job: any) => {
                if (job.objectId === jobId) {
                    if (!job.modelYears) job.modelYears = [];
                    const modelYear = job.modelYears ? job.modelYears.find((p: any) => parseInt(p, 10) === selectedModelYear) : undefined;
                    if (modelYear) {
                        job.modelYears = job.modelYears.filter((p: any) => parseInt(p, 10) !== selectedModelYear);
                    } else if (job.modelYears) {
                        job.modelYears.push(selectedModelYear.toString());
                    }
                }
                return job;
            });
            return {...linkedSystem, jobs: updatedJobs};
        });

        const updatedJobIds: number[] = this.state.updatedJobIds;
        if (updatedJobIds.indexOf(jobId) === -1) {
            updatedJobIds.push(jobId);
        }
        this.setState({jobs: [...updatedLinkedJobs], updatedJobIds: [...updatedJobIds]});
    }
    handleTranslationServiceChange = (_e: any, {value}: any) => {
        this.setState({translationService: value});
    }
    onSave = () => {
        const {client, baseLinks, modelYears} = this.props;
        const {jobs, updatedJobIds} = this.state;
        if (baseLinks) {
            this.props.addLoadingMessage('Saving jobs');
            const getUpdatedJobs = jobs.map((linkedSystem: any) => linkedSystem.jobs.filter((job: any) => updatedJobIds.indexOf(job.objectId) !== -1)).flat();

            const promises = getUpdatedJobs.map((job: JobsDto) => {
                const payload: JobsDto = {
                    name: job.name,
                    active: job.active,
                    modelYears: job.modelYears,
                    linkedSystem: job.linkedSystem,
                    objectId: job.objectId,
                    versionId: job.versionId,
                    updatedBy: job.updatedBy,
                    lastUpdatedByJob: job.lastUpdatedByJob,
                    status: job.status,
                    lastSuccessOn: job.lastSuccessOn,

                };
                return client.PATCH_updateJobByName(baseLinks).execute(payload);
            });
            Promise.all(promises).then(() => {
                this.props.removeLoadingMessage('Saving jobs');
                this.setState({updatedJobIds: []});
                this.loadJobs();
            });
        }
    }
    onSaveTranslationService = () => {
        const {client, baseLinks} = this.props;
        const {translationService} = this.state;
        if (baseLinks) {
            this.props.addLoadingMessage('Saving translation service');
            const payload: TranslationServiceDto = {
                service: translationService,
            };
            client.PATCH_translationService(baseLinks).execute(payload).then(() => {
                this.props.removeLoadingMessage('Saving translation service');
                this.loadTranslationService();
                this.props.ReceiveTranslationServiceAction(payload);
            }).catch(() => {
                this.props.removeLoadingMessage('Saving translation service');
            });
        }
    }
    onChooseStatus = (job: JobsDto) => {
        if (!job.status) return undefined;
        if (job.status === "SUCCESS" && !job.lastUpdatedByJob) return 'green';

        if (job.status === "SUCCESS" && job.lastUpdatedByJob > job.lastSuccessOn) {
            return 'red';
        } else if (job.status === "SUCCESS" && job.lastUpdatedByJob <= job.lastSuccessOn) {
            return 'green';
        } else if (job.status === "FAILED") {
            return 'red';
        }
        return undefined;
    }

    render() {
        const {activeIndex, parentActiveIndex, jobs} = this.state;
        const {modelYears, t, userDetails} = this.props;
        const hasPrivilege = userDetails && userDetails.privileges &&
            userDetails.privileges.some((priv: any) =>
            priv.identifier === 'ADMIN_AREA_READ' || priv.identifier === 'ADMIN_AREA_WRITE'
        );
        return (
            <Grid className='managementview_container'>
                <GridRow columns={12} className='grid_header'>
                    <GridColumn width={13} className='job_title'>
                        {t('SYNC_JOBS')}
                    </GridColumn>
                    <GridColumn width={3} className='save_btn_grid'>
                        <Button icon='save' label={'Save'} labelPosition='after' onClick={this.onSave} />
                    </GridColumn>
                </GridRow>
                <GridRow columns={16}>
                    <GridColumn width={5}>
                        <Label className='header'>{t('NAME')}</Label>
                    </GridColumn>
                    <GridColumn width={2}>
                        <Label className='header'>{t("ACTIVE_INACTIVE")}</Label>
                    </GridColumn>
                    <GridColumn width={4} className='job_toggle'>
                        <Label className='header'>
                            {t("STATUS_LAST_RUN")}
                        </Label>
                        <Popup trigger={<Icon name='info' size='tiny' circular={true} />} position="top center">
                            {t("TIMESTAMP_HINT")}
                        </Popup>
                    </GridColumn>
                    <GridColumn width={4} className='job_toggle'>
                        <Label className='header'>{t("LAST_SUCCESS_ON")}</Label>
                        <Popup trigger={<Icon name='info' size='tiny' circular={true} />} position="top center">
                            {t("TIMESTAMP_HINT")}
                        </Popup>
                    </GridColumn>
                </GridRow>

                <GridRow columns={12}>
                    <Accordion activeIndex={parentActiveIndex} style={{'width': '100%'}}>
                        {jobs.map((linkedSystem: any, pindex: number) => (
                            <div key={pindex}>
                                <AccordionTitle key={pindex} index={pindex} active={parentActiveIndex === pindex}>
                                    <Grid className='accordian_title'>
                                        <GridRow columns={12}>
                                            <GridColumn width={6}>
                                                <Icon name='dropdown' onClick={() => this.handleParentClick(pindex)} />
                                                {/* <Checkbox
                                                    label={linkedSystem.linkedSystem}
                                                    disabled={true}
                                                /> */}
                                                <Label basic={true}>{linkedSystem.linkedSystem}</Label>
                                            </GridColumn>
                                        </GridRow>
                                    </Grid>
                                </AccordionTitle>
                                <AccordionContent active={parentActiveIndex === pindex} className='accordion_content'>
                                    {linkedSystem.jobs && linkedSystem.jobs.map((job: any, index: number) => (
                                        <>
                                            <AccordionTitle key={index} index={index} active={activeIndex === index}>
                                                <Grid className='accordian_title'>
                                                    <GridRow columns={16}>
                                                        <GridColumn width={5} className='date_text'>
                                                            {job.name === 'EXPORT_OPTION_TEXT' && <Icon name='dropdown' onClick={() => this.handleClick(index)} />}
                                                            <span>{t(job.name)}</span>
                                                        </GridColumn>
                                                        <GridColumn width={2} className='job_toggle date_text'>
                                                            <Checkbox id={job.objectId} toggle={true} checked={job.active} onChange={this.handleActiveInactive} />
                                                        </GridColumn>
                                                        <GridColumn width={4}>
                                                            <div style={{marginLeft: '30px'}}>
                                                                <TrafficLight
                                                                    config={config}
                                                                    lastUpdatedOn={job.lastUpdatedByJob}
                                                                    initialColor={this.onChooseStatus(job)}
                                                                />
                                                            </div>
                                                        </GridColumn>
                                                        <GridColumn width={4} className='date_text'>
                                                            {job.lastSuccessOn &&
                                                                <span style={{marginLeft: '30px'}}>
                                                                    {DateFormatter.applyDateTime24HRSFormat(job.lastSuccessOn) || ""}
                                                                </span>
                                                            }
                                                        </GridColumn>
                                                    </GridRow>
                                                </Grid>
                                            </AccordionTitle>
                                            {job.name === 'EXPORT_OPTION_TEXT' &&
                                                <AccordionContent active={activeIndex === index}>
                                                    <div className='model_years'>
                                                        {(modelYears && modelYears.elements)
                                                            && modelYears.elements.sort((a, b) => a.mj4 - b.mj4).map((modelYear) => {
                                                                const checked = job.modelYears && job.modelYears.find((p: any) => parseInt(p, 10) === modelYear.mj4) ? true : false;
                                                                return (
                                                                    <div key={modelYear.objectId} >
                                                                        <Checkbox
                                                                            disabled={!job.active}
                                                                            label={modelYear.mj4}
                                                                            checked={checked}
                                                                            onChange={() => this.handleModelYearChange(job.objectId, modelYear.mj4)}
                                                                        />
                                                                    </div>
                                                                );
                                                            })}
                                                    </div>
                                                </AccordionContent>
                                            }
                                        </>
                                    ))}
                                </AccordionContent >
                            </div>
                        ))}
                    </Accordion>
                </GridRow>
                {hasPrivilege && (
                    <>
                <GridRow columns={12} className='grid_header'>
                    <GridColumn width={13} className='job_title'>
                        {t('TRANSLATION_SERVICE')}
                    </GridColumn>
                    <GridColumn width={3} className='save_btn_grid'>
                        <Button icon='save' label={'Save'} labelPosition='after' onClick={this.onSaveTranslationService} />
                    </GridColumn>
                </GridRow>
                <GridRow columns={16}>
                    <GridColumn width={16}>
                        <div style={{marginTop: 10}}>
                            <Radio
                                label="AWS Translate"
                                name="translationService"
                                value="AWS_TRANSLATE"
                                checked={this.state.translationService === "AWS_TRANSLATE"}
                                onChange={this.handleTranslationServiceChange}
                                style={{marginRight: 30}}
                            />
                            <Radio
                                label="AWS Bedrock"
                                name="translationService"
                                value="AWS_BEDROCK"
                                checked={this.state.translationService === "AWS_BEDROCK"}
                                onChange={this.handleTranslationServiceChange}
                            />
                        </div>
                    </GridColumn>
                </GridRow>
                </>
                )}
            </Grid >
        );
    }
}

const mapStateToProps = (state: IReduxState) => ({
    userDetails: state.general.userDetails,
    baseLinks: state.general.baseLinks,
    client: state.general.client,
    modelYears: state.general.modelYears
});

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => ({
    addLoadingMessage: (message: string) => dispatch(GeneralActions.AddLoadingMessage(message)),
    removeLoadingMessage: (message: string) => dispatch(GeneralActions.RemoveLoadingMessage(message)),
    ReceiveTranslationServiceAction: (payload: any) => dispatch(GeneralActions.ReceiveTranslationServiceAction(payload))
});

export default compose<React.ComponentType<any>>(
    connect(mapStateToProps, mapDispatchToProps)
)(TechnicalTab);



// WEBPACK FOOTER //
// ./src/views/ManagementView/TechanicalTab.tsx